import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import UIComponent from './uiComponent';
import { Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
const { Dragger } = Upload;
function UIUploaderComponent(props) {
    const [value, setValue] = useState(props.file ? [props.file] : []);
    useEffect(() => {
        setValue(props.file ? [props.file] : []);
    }, [props.value]);
    const handleChange = (file) => {
        setValue([file]);
        props.beforeUpload(file);
        return false;
    };
    const handleRemove = () => {
        setValue([]);
        props.beforeUpload(null);
        return false;
    };
    return (_jsxs(Dragger, { style: { marginTop: '20px' }, beforeUpload: handleChange, onRemove: handleRemove, fileList: value, accept: ".pdf", maxCount: 1, children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(InboxOutlined, {}) }), _jsx("p", { className: "ant-upload-text", children: props.title }), _jsxs("p", { className: "ant-upload-hint", children: [" ", props.subTitle] })] }));
}
export default class UIUploader extends UIComponent {
    title;
    subTitle;
    file = null;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        this.subTitle = this.getProperty('subTitle');
    }
    getComponent() {
        const props = {
            title: this.title,
            subTitle: this.subTitle,
            file: this.file,
            beforeUpload: (file) => {
                this.file = file;
                return false; // Prevent automatic upload
            },
        };
        return _jsx(UIUploaderComponent, { ...props });
    }
}
//# sourceMappingURL=uiUploader.js.map